<template>
  <div class="influencer-dashboard">
    <h2 class="mb-3">Influencer Paylaşım Takibi</h2>
    <ul class="nav nav-tabs mb-3">
      <li class="nav-item">
        <button
          type="button"
          class="nav-link"
          :class="{ active: activeTab === 'influencers' }"
          @click="activeTab = 'influencers'"
        >
          Influencerlar
        </button>
      </li>
      <li class="nav-item">
        <button
          type="button"
          class="nav-link"
          :class="{ active: activeTab === 'agreements' }"
          @click="activeTab = 'agreements'"
        >
          Paylaşım Hakkı Anlaşmaları
        </button>
      </li>
      <li class="nav-item">
        <button
          type="button"
          class="nav-link"
          :class="{ active: activeTab === 'posts' }"
          @click="activeTab = 'posts'"
        >
          Paylaşımlar
        </button>
      </li>
    </ul>

    <InfluencerListTab v-show="activeTab === 'influencers'" />
    <InfluencerAgreementTab v-show="activeTab === 'agreements'" />
    <InfluencerPostTab v-show="activeTab === 'posts'" />
  </div>
</template>

<script>
import InfluencerListTab from './InfluencerListTab.vue';
import InfluencerAgreementTab from './InfluencerAgreementTab.vue';
import InfluencerPostTab from './InfluencerPostTab.vue';

export default {
  name: 'InfluencerDashboard',
  components: { InfluencerListTab, InfluencerAgreementTab, InfluencerPostTab },
  data() {
    return {
      activeTab: 'influencers',
    };
  },
};
</script>

<style scoped>
.influencer-dashboard {
  max-width: 1400px;
  margin: 0 auto;
}
</style>
